import { styled } from '@mui/material';
import { forwardRef, type JSX } from 'react';

import { colorSystem } from '../../theme';
import { Text } from '../Text';

export interface ReleaseTagProps {
    color: 'primary' | 'violet' | 'white';
    label: string | JSX.Element;
    size?: 'medium' | 'small';
}

const colors = {
    violet: {
        color: colorSystem.neutral.white,
        background: 'linear-gradient(90deg, #8D7DF3 0.27%, #7061D1 99.52%)',
    },
    primary: {
        color: colorSystem.neutral.white,
        background: `linear-gradient(90deg, ${colorSystem['primary'][6]} 0.27%, ${colorSystem['primary'][7]} 99.52%)`,
    },
    white: {
        color: colorSystem.primary[7],
        background: `linear-gradient(90deg, ${colorSystem['neutral'][1]} 0.27%, ${colorSystem['neutral'][2]} 99.52%)`,
    },
};

export const ReleaseTag = forwardRef<HTMLDivElement, ReleaseTagProps>(({ color, label, size = 'medium' }, ref) => {
    const textColor = colors[color].color;
    const background = colors[color].background;

    switch (size) {
        case 'small':
            return (
                <SmallReleaseTag variant="caption" color={textColor} style={{ backgroundImage: background }} ref={ref}>
                    {label}
                </SmallReleaseTag>
            );
        case 'medium':
            return (
                <MediumReleaseTag variant="h5" color={textColor} style={{ backgroundImage: background }} ref={ref}>
                    {label}
                </MediumReleaseTag>
            );
    }
});

const SmallReleaseTag = styled(Text)({
    padding: '1px 3px',
    borderRadius: '3px',
});

const MediumReleaseTag = styled(Text)({
    padding: '2px 4px',
    borderRadius: '4px',
});
